module.exports = __webpack_public_path__ + "img/user Icon.70224a72.svg";